import React from 'react';

const BlogArticle = ({ post, onBack }) => {
    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    if (!post) {
        return (
            <div className="min-h-screen bg-white flex items-center justify-center">
                <div className="text-center">
                    <h2 className="text-2xl font-light text-stone-800 mb-4">Article not found</h2>
                    <button
                        onClick={onBack}
                        className="text-stone-700 hover:text-stone-900 underline"
                    >
                        Back to Blog
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-white">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                {/* Back button */}
                <button
                    onClick={onBack}
                    className="flex items-center text-stone-600 hover:text-stone-800 mb-8 transition-colors"
                >
                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                    Back to Blog
                </button>

                {/* Article header */}
                <header className="mb-8">
                    <div className="flex items-center justify-between mb-4">
                        <span className="inline-block bg-amber-100 text-amber-700 text-sm font-medium px-3 py-1 rounded-full">
                            {post.category}
                        </span>
                        <span className="text-stone-500 text-sm">
                            {formatDate(post.date)}
                        </span>
                    </div>

                    <h1 className="text-3xl sm:text-4xl lg:text-5xl font-light text-stone-800 leading-tight mb-6">
                        {post.title}
                    </h1>

                    {/* Featured image */}
                    {post.featuredImage && (
                        <div className="w-full h-64 sm:h-80 lg:h-96 mb-8 rounded-xl overflow-hidden">
                            <img
                                src={post.featuredImage}
                                alt={post.title}
                                className="w-full h-full object-cover"
                            />
                        </div>
                    )}

                    <p className="text-xl text-stone-600 leading-relaxed">
                        {post.excerpt}
                    </p>
                </header>

                {/* Article content */}
                <article className="prose prose-stone max-w-none">
                    {post.content ? (
                        <div
                            dangerouslySetInnerHTML={{ __html: post.content }}
                            className="text-lg leading-relaxed text-stone-700"
                        />
                    ) : (
                        <div className="text-lg leading-relaxed text-stone-700 space-y-6">
                            <p>
                                This is where the full article content would appear. Currently, this is placeholder content
                                that demonstrates how a full blog article would be displayed.
                            </p>
                            <p>
                                In a real implementation, you would store the full article content in your database
                                and display it here. The content could include rich formatting, images, and other media.
                            </p>
                            <p>
                                You can add a rich text editor to your admin panel to allow full content creation and editing.
                            </p>
                        </div>
                    )}
                </article>

                {/* Article footer */}
                <footer className="mt-12 pt-8 border-t border-stone-200">
                    <div className="flex items-center justify-between">
                        <button
                            onClick={onBack}
                            className="text-stone-700 hover:text-stone-900 underline"
                        >
                            Back to Blog
                        </button>

                        <div className="text-sm text-stone-500">
                            Article published {formatDate(post.date)}
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default BlogArticle;